import React from 'react';
import { pick, orderBy } from 'lodash';
import { Link } from 'react-router-dom';
import { format as formatDate } from 'date-fns';

import AdminPage from '../hocs/AdminPage';
import firebase from '../../firebase';
import { adminFields as fields, plans, features, } from '../../shared/models/company';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import ModelFormModal from '../modals/ModelFormModal';
import EditButton from '../EditButton';
import ExportButton from '../ExportButton';

const { entries } = Object;
const db = firebase.firestore();
const companiesRef = db.collection('companies');

const toDate = _ => _?.toDate ? _.toDate() : _;

export default AdminPage(function AdminCompanies(props) {
  const { canWrite } = props;
  const companies = useCollectionSubscription(companiesRef);
  const sortedCompanies = orderBy(companies, _ => toDate(_.createdAt)?.getTime() ?? 0, 'desc');

  const rowsForExport = () => sortedCompanies.map((_) => {
    const createdAt = toDate(_.createdAt);
    return {
      作成日時: createdAt ? formatDate(createdAt, 'YYYY/MM/DD HH:mm:ss') : '',
      事業所名: _.display_name,
      事業所ID: _.id,
      プラン: entries(pick(plans, _.enabledPlans)).map(([, v]) => v.label).join(', '),
      トライアル: _.isTrial ? 'トライアル' : '',
    };
  });

  return (
    <div className="company-members">
      <div className="container py-5">
        <div className="d-flex justify-content-center mb-2">
          <h3>会社管理</h3>
        </div>
        <div className="d-flex justify-content-end mb-2">
          <ExportButton outline fileName="事業所一覧.csv" rows={rowsForExport} />
        </div>
        <table className="table table-hover mt-5 table-bordered">
          <thead class="thead-light">
            <tr>
              <th>会社名</th>
              <th>試用期間(日)</th>
              <th>ライセンス数</th>
              <th>トライアル</th>
              <th>プラン</th>
              <th>オプション</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              sortedCompanies.map(({ id, ref, display_name: name, trialDays = 30, licenseCount = 10, isTrial, enabledPlans, enabledFeatures = [], shouldDelete = false, }) => {
                return (
                  <tr key={id} id={id}>
                    <td>
                      <div className="small text-muted">{id}</div>
                      <Link to={`/companies/${id}`}>
                        {name}
                      </Link>
                      {shouldDelete && <div className="ml-1 badge badge-danger">削除予定</div>}
                    </td>
                    <td className="text-right">
                      {trialDays}
                    </td>
                    <td className="text-right">
                      {licenseCount}
                    </td>
                    <td className="text-right">
                      {isTrial && <span className="badge badge-info">トライアル</span>}
                    </td>
                    <td className="text-right">
                      {entries(pick(plans, enabledPlans)).map(([k, v]) => <div key={k}>{v.label}</div>)}
                    </td>
                    <td className="text-right">
                      {enabledFeatures?.map(_ => features[_]?.label).join(', ')}
                    </td>
                    <td>
                      {canWrite && (
                        <EditButton itemRef={ref} FormModal={ModelFormModal} formProps={{ title: '会社 編集', fields: fields() }} />
                      )}
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    </div>
  );
});
